<template>
	<div>
		<v-layout row class="mb-5">
			<v-flex xs12 sm12 md6>
				<p class="add-event-step-header">Now, let's give your spot a name...</p>
				<p class="mt-2 add-event-step-sub-header">... and in a few words describe this space.</p>
				<p class="add-event-step-secondary-header mb-1">Location Name</p>
				<p class="add-event-step-sub-header mb-0">Shown as: 'Event Title @ Location Name'</p>
				<v-text-field color="link" class="add-event-text-box" v-model="title" placeholder="Enter location name"></v-text-field>
				<!-- <el-input v-model="title" class="mt-1 mb-4"></el-input> -->
				<p class="add-event-step-secondary-header mb-1">Location Description</p>
				<p class="add-event-step-sub-header mb-0">Try pointing out things that make this location special or unique! :)</p>
				<!-- <el-input
					class="mt-1 mb-4"
					type="textarea"
					:rows="2"
					v-model="description">
				</el-input> -->
				<v-textarea color="link" class="add-event-text-box mt-2 pt-0" v-model="description" placeholder="Enter location description"></v-textarea>
				<p class="add-event-step-secondary-header mb-1">Space Rules</p>
				<p class="add-event-step-sub-header mb-0">Giving guests a head's up helps them come prepared.  A shoe free zone? Backyard off limits? Let us know!</p>
				<v-textarea color="link" class="add-event-text-box mt-2 pt-0" v-model="rules" placeholder="Enter location rules" validate-on-blue></v-textarea>
				<!-- <el-input
					class="mt-1 mb-4"
					type="textarea"
					:rows="2"
					v-model="rules">
				</el-input> -->
				<!-- <v-btn color="primary" dark @click.stop="exampleOpen = !exampleOpen" class="hidden-md-and-up">Open Dialog 3</v-btn> -->
			</v-flex>

			<v-flex xs12 md4 offset-md1 hidden-sm-and-down class="pt-3">
				<v-card class="add-event-tip-box">
					<v-card-text class="p-relative pt-5">
						<div class="info-trapezoid p-absolute">
							<div class="info-content">
								<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
							</div>
						</div>
						<div>
							<p class="add-event-tip-content"><i>What's in a NAME? Would a rose by any other name smell as sweet?</i></p>
							<p class="add-event-tip-content">Check these examples to get ideas:</p>
						</div>
						<p class="text-xs-center add-event-example-sub-header-light"><v-btn small icon @click="lastExample"><v-icon class="example-toggle-icon">fa-chevron-left</v-icon></v-btn>Example {{exampleIndex+1}}/{{examples.length}}<v-btn small icon @click="nextExample"><v-icon class="example-toggle-icon">fa-chevron-right</v-icon></v-btn></p>
						<p class="add-event-example-sub-header">{{ examples[exampleIndex].title }}</p>
						<p class="add-event-example-content"><span class="bolded">Location Description</span> - {{ examples[exampleIndex].description }}</p>
						<p class="add-event-example-content"><span class="bolded">Space Rules</span> - {{ examples[exampleIndex].rules }}</p>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<div class="d-block text-xs-center" style="width: 100%;">
						<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
					</div>
					<p style="display: block;" class="add-event-example-sub-header-light">Example {{exampleIndex+1}}/{{examples.length}}</p>
				</v-card-title>
				<v-card-text style="height: 50vh;">
					<p class="add-event-example-sub-header">{{ examples[exampleIndex].title }}</p>
					<p class="add-event-example-content"><span class="bolded">Description</span> - {{ examples[exampleIndex].description }}</p>
					<p class="add-event-example-content"><span class="bolded">Rules</span> - {{ examples[exampleIndex].rules }}</p>
				</v-card-text>
				<v-card-actions>
					<v-btn small icon @click="lastExample"><v-icon class="example-toggle-icon">fa-chevron-left</v-icon></v-btn>
					<v-btn small icon @click="nextExample"><v-icon class="example-toggle-icon">fa-chevron-right</v-icon></v-btn>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	data() {
		return {
			exampleIndex: 0,
			exampleOpen: false,
			examples: [
				{
					title: "Sophie's Sanctuary",
					description:
						"Sophia's is a secluded modern cottage hidden within a luscious garden. Beautiful artwork, vaulted ceilings, and serence views in every direction. Plenty of seating options to choose from (both inside and outside). Perfect for focus and flow and just steps away for Abbot Kinney (great spot for lunch!).",
					rules: 'Please, no shoes inside the house'
				},
				{
					title: 'Dev House',
					description:
						"At Dev House you'll find a productive work environment with plenty of workstation options, a foosball table, and an outdoor patio.  All are welcome here, and for those who need we have a few extra monitors.",
					rules:
						"No upstairs access.  Any smoking must be done in the backyard.  If you'd like to cook in the kitchen there are utensils for you to use. Just make sure to clean up after yourself."
				},
				{
					title: 'The Bungalow',
					description:
						'A stone throw from the beach!  The space includes a rooftop deck (with hammock!), a balcony overlooking the Venice Canal, and a cozy interior design with a huge community table and many other individual spots to work.  Note: an adorable cat lives here!',
					rules:
						'Shoe free house!  Please be extra friendly if you meet neighbors while entering or exiting the building.  Thanks!'
				}
			]
		}
	},
	beforeRouteLeave(to, from, next) {
		if (
			![this.title, this.description].includes(null) &&
			this.title &&
			this.description
		) {
			this.setAddLocationValidStep(from.path)
			this.removeAddLocationInvalidStep(from.path)
		} else {
			this.removeAddLocationValidStep(from.path)
			this.setAddLocationInvalidStep(from.path)
		}
		next()
	},
	methods: {
		...mapActions([
			'setAddLocationProp',
			'setAddLocationInvalidStep',
			'removeAddLocationInvalidStep',
			'setAddLocationValidStep',
			'removeAddLocationValidStep'
		]),
		lastExample() {
			this.exampleIndex -= 1
			if (this.exampleIndex < 0) {
				this.exampleIndex = this.examples.length - 1
			}
		},
		nextExample() {
			this.exampleIndex += 1
			if (this.exampleIndex >= this.examples.length) {
				this.exampleIndex = 0
			}
		}
	},
	computed: {
		...mapGetters(['getAddLocationProp']),
		title: {
			get() {
				return this.getAddLocationProp('title')
			},
			set(val) {
				this.setAddLocationProp({
					prop: 'title',
					value: val
				})
			}
		},
		description: {
			get() {
				return this.getAddLocationProp('description')
			},
			set(val) {
				this.setAddLocationProp({
					prop: 'description',
					value: val
				})
			}
		},
		rules: {
			get() {
				return this.getAddLocationProp('rules')
			},
			set(val) {
				this.setAddLocationProp({
					prop: 'rules',
					value: val
				})
			}
		},
		infoDialog: {
			get() {
				return this.getAddLocationProp('infoDialog')
			},
			set(val) {
				this.setAddLocationProp({ prop: 'infoDialog', value: val })
			}
		}
	}
}
</script>

<style>
</style>
